"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Triangle = void 0;
const gl_matrix_1 = require("gl-matrix");
const ShapeHelper_1 = require("./ShapeHelper");
/**
 * Triangle Shape
 */
class Triangle {
    /**
     * Private constructor, use static creation methods instead.
     *
     * @param p1 1st point of the triangle
     * @param p2 2nd point of the triangle
     * @param p3 3rd point of the triangle
     */
    constructor(p1, p2, p3) {
        this.p1 = p1;
        this.p2 = p2;
        this.p3 = p3;
    }
    /**
     * Creates a Triangle instance described by the triangle JSON.
     *
     * @param contourJson The triangle JSON
     */
    static fromJson(triangleJson) {
        return new Triangle(gl_matrix_1.vec2.fromValues(triangleJson.P1[0], triangleJson.P1[1]), gl_matrix_1.vec2.fromValues(triangleJson.P2[0], triangleJson.P2[1]), gl_matrix_1.vec2.fromValues(triangleJson.P3[0], triangleJson.P3[1]));
    }
    /**
     * Creates an JSON object out of the triangle instance.
     */
    toJson() {
        return {
            P1: [this.p1[0], this.p1[1]],
            P2: [this.p2[0], this.p2[1]],
            P3: [this.p3[0], this.p3[1]],
        };
    }
    /**
     * Test if the point is inside the triangle or on the triangle contour.
     *
     * @param point A 2D point
     */
    isPointInShape(point) {
        return ShapeHelper_1.ShapeHelper.isPointInShape([this.p1, this.p2, this.p3], point) !== ShapeHelper_1.IsPointInShape.OutsideOfShape;
    }
    /**
     * Transform the triangle by the given matrix.
     *
     * @param transform The transformation matrix.
     */
    transform(transform) {
        const transformedP1 = gl_matrix_1.vec2.create();
        const transformedP2 = gl_matrix_1.vec2.create();
        const transformedP3 = gl_matrix_1.vec2.create();
        gl_matrix_1.vec2.transformMat2d(transformedP1, this.p1, transform);
        gl_matrix_1.vec2.transformMat2d(transformedP2, this.p2, transform);
        gl_matrix_1.vec2.transformMat2d(transformedP3, this.p3, transform);
        return new Triangle(transformedP1, transformedP2, transformedP3);
    }
}
exports.Triangle = Triangle;
//# sourceMappingURL=Triangle.js.map